import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDunningCreate,
  detail: routeDunningDetail,
  home: routeDunningsHome,
  root: routeDunningsRoot,
} = createDoctypeRoutes({
  createName: 'new-dunning',
  createPath: 'new-dunning',
  detailName: 'dunningDetail',
  doctype: DOCTYPES.DUNNING,
  homeName: 'dunnings-home',
  path: 'dunnings',
  views: {
    create: async () => await import('@/components/viewsExternal/dunnings/AddDunning.vue'),
    detail: async () => await import('@/components/viewsExternal/dunnings/ViewDunning.vue'),
    list: async () => await import('@/components/viewsExternal/dunnings/DunningView.vue'),
  },
})

export { routeDunningCreate, routeDunningDetail, routeDunningsHome, routeDunningsRoot }
